import { render, staticRenderFns } from "./supervisores.vue?vue&type=template&id=237f6390"
import script from "./supervisores.vue?vue&type=script&lang=js"
export * from "./supervisores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports